module.exports = __webpack_public_path__ + "img/sports-and-outdoors.7929f893.svg";